import React, { useCallback, useEffect, useRef, useState } from "react"

import styles from "./ticket.module.css"
import throttle from "lodash.throttle"
import { useTranslation } from "react-i18next"

export default function Ticket() {
  const { i18n } = useTranslation()
  const currentLang = i18n.language
  const ref = useRef()

  const [animated, setAnimated] = useState(false)

  const listenToScroll = useCallback(() => {
    if (ref.current.getBoundingClientRect().top) {
      if (ref.current.getBoundingClientRect().top < 400 && !animated) {
        setAnimated(true)
      }
    }
  }, [animated])

  // Use throttle for performance
  const listenToScrollThrottled = throttle(listenToScroll, 250)

  useEffect(() => {
    if (!animated) {
      window.addEventListener("scroll", listenToScrollThrottled)
    }

    return () => window.removeEventListener("scroll", listenToScrollThrottled)
  }, [animated, listenToScrollThrottled])

  return (
    <div
      className={`${styles.scanCodeTicket} ${
        currentLang === "es" ? styles.scanCodeTicketES : styles.scanCodeTicketEN
      } ${animated ? styles.scanCodeTicketAnimated : ""}`}
      ref={ref}
    ></div>
  )
}
